<template>
  <div class="yearNoData">
    <div class="noData" :style="'background: url(' + bgImgArr[0] + ')'">
      <div class="isNoData-text aliText">
        <div>这一年我们没有太多交集哦，</div>
        <div>2021让我们一起探索更多可能！</div>
      </div>
      <img class="swipe-1-2" :src="imgArr[0]">
    </div>
  </div>
</template>

<script>
export default {
  name: "yearNoData",
  components: {},
  data() {
    return {
      imgArr: [
        'https://prodzwy.ks3-cn-shanghai.ksyun.com/yearbillsrc/swipe-1-2.png'
      ],
      bgImgArr: [
        'https://prodzwy.ks3-cn-shanghai.ksyun.com/yearbillsrc/noData.jpg'
      ]
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
  .yearNoData {
    position: relative;
    height: 100%;
    width: 100%;
  }

  .isNoData-text {
    position: absolute;
    color: #ffffff;
    width: 100%;
    text-align: center;
    font-size: 0.18rem;
    line-height: 0.28rem;
    top: 16%;
  }
  .noData {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-position:center center !important;
    background-repeat:no-repeat !important;
    background-size: cover !important;
  }
  .swipe-1-2 {
    position:absolute;
    bottom: 3%;
    left: 5%;
    width: 30%;
  }
</style>
